import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findCountries = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/countries${query}`,
    {
      headers,
    },
  );
};

export const findCountryById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/countries/${id}`,
    {
      headers,
    },
  );
};

export const createCountry = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_CATEGORY_API_URL}/countries`,
    data,
    {
      headers,
    },
  );
};

export const updateCountry = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/countries/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteCountry = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/countries/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteCountries = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/countries?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
